// Fullscreen image viewer — ports lightbox.js. Click backdrop / ✕ / Escape to close.
import { useEffect } from 'react'
import { useLightboxStore } from '../store/lightboxStore'
import styles from './Lightbox.module.css'

export default function Lightbox() {
  const src = useLightboxStore((s) => s.src)
  const close = useLightboxStore((s) => s.close)

  // Close on Escape while open (original lightbox.js:26-30).
  useEffect(() => {
    if (!src) return undefined
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [src, close])

  if (!src) return null
  return (
    <div className={styles.backdrop} onClick={close}>
      <button className={styles.close} onClick={close} aria-label="Закрыть">✕</button>
      <img className={styles.img} src={src} alt="" onClick={(e) => e.stopPropagation()} />
    </div>
  )
}
